import { ProgramObject } from '@/types/epg/Program'
import { serializable, serialize } from 'serializr'
import { getNumericWeekDay } from '../helpers/dateHelpers'

class Program {
    @serializable id: string
    @serializable startMilis: number
    @serializable endMilis: number
    @serializable rating: string
    @serializable name: string
    @serializable shortDescription: string
    @serializable description: string
    @serializable durationMilis: number
    @serializable catchup?: number
    @serializable contentNumber?: string
    @serializable contentType?: string
    @serializable language?: string
    @serializable poster?: string
    @serializable numericWeekDay: number
    @serializable genre: string

    constructor(programProps: ProgramObject) {
        this.id = programProps.id
        this.startMilis = programProps.startMilis
        this.endMilis = programProps.endMilis
        this.rating = programProps.rating
        this.name = programProps.name
        this.shortDescription = programProps.shortDescription
        this.description = programProps.description
        this.durationMilis = programProps.durationMilis
        this.catchup = programProps.catchup
        this.contentNumber = programProps.contentNumber
        this.contentType = programProps.contentType
        this.language = programProps.language
        this.poster = programProps.poster
        this.numericWeekDay = getNumericWeekDay(this.startMilis)
        this.genre = this.getGenre()
    }

    getGenre = () => {
        switch (this.contentType) {
            case '1':
                switch (this.contentNumber) {
                    case '4':
                        return 'genreComedy'
                    case '0':
                        return 'genreDrama'
                    default:
                        return 'genreMovies'
                }
            case '2':
                return 'genreNews'
            case '3':
                return 'genreEntertainment'
            case '4':
                return 'genreSport'
            case '5':
                return 'genreFamilyKids'
            case '6':
                return 'genreMusic'
            case '7':
                return 'genreArts'
            case '8':
                return 'genreLifestyle'
            case '9':
                switch (this.contentNumber) {
                    case '1':
                        return 'genreAnimalWildlife'
                    case '2':
                        return 'genreTechScience'
                    default:
                        return 'genreEducation'
                }
            case '10':
                switch (this.contentNumber) {
                    case '6':
                        return 'genreShopping'
                    case '1':
                        return 'GenreTravel'
                    default:
                        return 'GenreLifestyle'
                }
            default:
                return 'GenreOthers'
        }
    }

    static serialize(program: Program): string {
        return JSON.stringify(serialize(program))
    }

    static deserialize(programJson: string): Program

    // Updated deserialize method
    static deserialize(programJson: string): Program {
        // Deserialize the JSON to a Program object without immediately computing the genre
        const programObj = JSON.parse(programJson)

        return new Program(programObj)
    }
}

export default Program
